import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Auto-recover from stale dynamic module chunk errors after deployments
window.addEventListener('error', (event) => {
  const isChunkError = 
    event?.message?.includes('Failed to fetch dynamically imported module') ||
    event?.message?.includes('Loading chunk') ||
    event?.message?.includes('Importing a module script failed') ||
    (event?.error && String(event.error).includes('Failed to fetch dynamically imported module'));

  if (isChunkError) {
    const chunkReloadKey = 'chunk_reload_retry';
    const hasReloaded = sessionStorage.getItem(chunkReloadKey);
    if (!hasReloaded) {
      sessionStorage.setItem(chunkReloadKey, 'true');
      window.location.reload();
    }
  }
});

window.addEventListener('unhandledrejection', (event) => {
  const reasonStr = String(event?.reason || '');
  if (
    reasonStr.includes('Failed to fetch dynamically imported module') ||
    reasonStr.includes('Loading chunk') ||
    reasonStr.includes('Importing a module script failed')
  ) {
    const chunkReloadKey = 'chunk_reload_retry';
    const hasReloaded = sessionStorage.getItem(chunkReloadKey);
    if (!hasReloaded) {
      sessionStorage.setItem(chunkReloadKey, 'true');
      window.location.reload();
    }
  }
});

window.addEventListener('load', () => {
  setTimeout(() => sessionStorage.removeItem('chunk_reload_retry'), 5000);
});

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));

